import { Headline, SubHeadline } from '@sumup/circuit-ui';
import { withNoMargin } from '../hocs';

const NoMarginHeadline = withNoMargin(Headline);
const NoMarginSubHeadline = withNoMargin(SubHeadline);

export { NoMarginHeadline as Headline, NoMarginSubHeadline as SubHeadline };
